module.exports = __webpack_public_path__ + "media/graphics/Sync-a4a7605a.svg";